import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'
import { toast } from 'react-toastify'
import React, { useState, useEffect } from 'react'

import useAuth from 'store/AuthContext'
import OrdersPage from '../ordersPage/OrdersPage'
import ProfilePage from '../profilePage/ProfilePage'
import MobileSidebar from './components/MobileSidebar'
import AccountHeader from './components/AccountHeader'
import DesktopSidebar from './components/DesktopSidebar'

const AccountLayout = () => {
  const { path } = useRouteMatch()
  const history = useHistory()
  const location = useLocation()
  const { user, logOut } = useAuth()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const getActiveTab = () => {
    if (location.pathname.includes('/orders')) return 'orders'
    if (location.pathname.includes('/profile')) return 'profile'
    return 'orders'
  }

  const activeTab = getActiveTab()

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [sidebarOpen])

  const handleTabClick = tab => {
    setSidebarOpen(false)
    history.push(`/account/${tab}`)
  }

  const handleLogout = () => {
    setIsLoggingOut(true)
    try {
      logOut()
      toast.success('წარმატებით გამოხვედით სისტემიდან', {
        position: 'top-right',
        autoClose: 2000,
      })
      history.push('/')
    } catch (error) {
      console.error('Logout error:', error)
      toast.error('გამოსვლისას მოხდა შეცდომა', {
        position: 'top-right',
        autoClose: 3000,
      })
    } finally {
      setIsLoggingOut(false)
    }
  }

  return (
    <div className="-mt-32 md:mt-0 min-h-screen w-full overflow-x-hidden lg:grid lg:grid-cols-[auto,1fr]">
      <MobileSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        activeTab={activeTab}
        onTabClick={handleTabClick}
        onLogout={handleLogout}
        isLoggingOut={isLoggingOut}
      />

      <DesktopSidebar
        user={user}
        activeTab={activeTab}
        onTabClick={handleTabClick}
        onLogout={handleLogout}
        isLoggingOut={isLoggingOut}
      />

      <div className="mt-[125px] md:mt-[112px] w-full overflow-x-hidden">
        <AccountHeader
          activeTab={activeTab}
          onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
        />

        <main className="px-4 md:pl-6 md:pr-0 py-4 md:pt-8 max-w-6xl mx-auto w-full">
          <Switch>
            <Route exact path={`${path}/orders`}>
              <OrdersPage />
            </Route>
            <Route exact path={`${path}/profile`}>
              <ProfilePage />
            </Route>
            <Route exact path={path}>
              <Redirect to={`${path}/orders`} />
            </Route>
          </Switch>
        </main>
      </div>
    </div>
  )
}

export default AccountLayout
